export default "__VITE_ASSET__U2yAn6uC__"